<template>
  <div id="cd-operations-select" class="d-flex flex-column pb-2">
    <h5 class="text-center font-weight-bold p-2">Select Operation</h5>
    <div id="operation-buttons">
      <div
        v-for="operation in operations"
        :key="operation.id"
        :class="activeOperationClass(operation)"
        class="operation-option clickable d-flex align-items-center mb-2 ml-2 p-2 border"
        @click="setSelectedOperation(operation)"
      >
        <img src="/img/icons/no-company.png" style="width: 1.5rem; height: 1.5rem" class="mr-2" />
        <div id="Label" class="d-flex w-100 justify-content-center">
          {{ operation.name }}
        </div>
      </div>
    </div>
    <BushelSelect
      :label-active="'Operation'"
      :options="operations"
      :value="selectedOperation"
      track-by="id"
      label="name"
      :taggable="false"
      :allow-empty="false"
      no-deselect
      thin
      class="d-block d-md-none mb-4"
      @select="setSelectedOperation"
    />
  </div>
</template>

<script>
export default {
  props: {
    operations: { type: Array, required: true },
    selectedOperation: { type: Object, required: true },
    setSelectedOperation: { type: Function, requried: true },
  },
  methods: {
    activeOperationClass(operation) {
      const { id } = operation;
      if (id === this.selectedOperation.id) {
        return "active";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
#cd-operations-select {
  #operation-buttons {
    display: flex;
    flex-flow: wrap;
    @media screen and (max-width: 767px) {
      display: none;
    }
    .operation-option {
      border-radius: 0.3em;
      user-select: none;
      transition: background 700ms;
      width: 32%;
      @media screen and (max-width: 991px) {
        width: 100%;
      }
      &.active {
        background: lightgray;
      }
    }
  }
}
</style>
